import React, { createContext, useState, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [footerColor, setFooterColor] = useState({
    primary: '#023b19',
    secondary: '#046331'
  });

  return (
    <ThemeContext.Provider value={{ footerColor, setFooterColor }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
